<template>
    <common-modal width="extra-large" @emitEvent="emitEvent($event, ['close'])" @close="emitEvent({ name: 'close' })">
        <div>
            <common-page-header
                :heading="'Congratulations! You\’ve completed the demo.'"
                size="page-plain-header"
                contentSpacing="medium"
                :isCenter="true"
            ></common-page-header>
            <common-page-header
                :heading="'Please complete your registration to start making and tracking referrals.'"
                size="page-plain-header"
                contentSpacing="medium"
                :isCenter="true"
            ></common-page-header>
            <common-buttons>
                <common-button :label="'Restart demo'" type="secondary" size="large-long" @click="closeModal"></common-button>
                <common-button
                    :label="'Complete registration'"
                    type="primary"
                    size="large-long"
                    :isProcessing="isSending"
                    @click="confirm"
                ></common-button>
            </common-buttons>
        </div>
    </common-modal>
</template>

<script>
    import CommonPageHeader from '../common/CommonPageHeader.vue'
    import PracticeTypeEnum from '@/enums/PracticeTypeEnum'

    export default {
        components: { CommonPageHeader },

        props: {},

        data() {
            return {
                isSending: false,
            }
        },

        methods: {
            closeModal() {
                this.emitEvent({ name: 'close' })
            },

            confirm() {
                this.isSending = true
                const query = {
                    email: this.$auth.getUser().email,
                    pt:
                        this.$auth.getUser().practiceType === PracticeTypeEnum.DEMO_ANCILLARY
                            ? PracticeTypeEnum.ANCILLARY
                            : PracticeTypeEnum.PHYSICIAN,
                }

                this.$router.push({ name: 'auth.signup.update.demo', query })
            },
        },

        mounted() {},
    }
</script>

<style scoped lang="scss">
    @import 'styles/setup/_variables.scss';
</style>
